import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=4c63b393&scoped=true"
import script from "./photo.vue?vue&type=script&lang=js"
export * from "./photo.vue?vue&type=script&lang=js"
import style0 from "./photo.vue?vue&type=style&index=0&id=4c63b393&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63b393",
  null
  
)

export default component.exports